module.exports = __webpack_public_path__ + "img/cta_icon.c1b94800.svg";